import { ControlType, FormFieldBase } from './form-field-base.model';

export class AutocompleteFormField extends FormFieldBase<string> {
  controlType: ControlType = 'autocomplete';
}
